import React from 'react'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import Moment from 'moment-timezone'
import ReactGA from 'react-ga'
import { DataViewModalContainer, ContainerHeadingActionIcon,
  DashboardContainer, DashboardToolbarContainer,
  DashboardGraphContainer, DashboardGraphHeaderRow, DashboardGraphHeadingCell,
  DashboardGraphHeading, DashboardGraphExpandLinkRow, DashboardGraphExpandLinkCell, DashboardGraphExpandLink,
  DashboardGraphInnerContainer } from './styled-elements'
import CloseCircle from '../icons/CloseCircle'
import LoadingIndicator from './LoadingIndicator'
import ContainerHeading from '../layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import styledTheme from '../../styles/theme'
import { isSiteEligibleForAllTimeGraph } from '../../utils/userUtils'
import { createDashboardHoverSync } from './dashboardHoverSync'
import {
  buildRangeSelector,
  buildTimezoneOptions,
  convertDegreesToIconAngle,
  formatSeries,
  formatYAxis,
} from './highchartsUtils'
import {
  attachWindDirectionRedrawHandler,
  initialiseHighcharts,
} from './highchartsSetup'

const Toolbar = ({dashboardToolbarExpandLinkClickHandler}) => <DashboardToolbarContainer>
  <a href="" onClick={dashboardToolbarExpandLinkClickHandler.bind(this)}>More charts/tables</a>
</DashboardToolbarContainer>

const Graph = React.forwardRef(({ title, options, state, children, graphExpandButtonClickHandler, siteSlug, dataViewSlug, siteEligibleForAllTimeGraph }, ref) => {
  const dataViewName = title
  return <DashboardGraphContainer>
    <DashboardGraphHeaderRow>
      <DashboardGraphHeadingCell><DashboardGraphHeading onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Graph - {title}</DashboardGraphHeading></DashboardGraphHeadingCell>
    </DashboardGraphHeaderRow>
    <DashboardGraphExpandLinkRow>

      <DashboardGraphExpandLinkCell>
        {!siteEligibleForAllTimeGraph && <DashboardGraphExpandLink onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Expanded 48H Graph</DashboardGraphExpandLink>}
        {siteEligibleForAllTimeGraph && <DashboardGraphExpandLink allHistory onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Expanded All-History Graph</DashboardGraphExpandLink>}
      </DashboardGraphExpandLinkCell>
    </DashboardGraphExpandLinkRow>

    <DashboardGraphInnerContainer id={`graph-container-${new Date().getTime()}`} ref={ref}>
      {children}
    </DashboardGraphInnerContainer>
  </DashboardGraphContainer>
  })

const RainfallGraph = React.forwardRef(({ title, options, state, children, graphExpandButtonClickHandler, siteSlug, dataViewSlug, siteEligibleForAllTimeGraph }, ref) => {
  const dataViewName = title
  return <DashboardGraphContainer>
    <DashboardGraphHeaderRow>
      <DashboardGraphHeadingCell><DashboardGraphHeading onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Graph - {title}</DashboardGraphHeading></DashboardGraphHeadingCell>
    </DashboardGraphHeaderRow>
    <DashboardGraphExpandLinkRow>
      <DashboardGraphExpandLinkCell>
        {!siteEligibleForAllTimeGraph && <DashboardGraphExpandLink onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Expanded 48H Graph</DashboardGraphExpandLink>}
        {siteEligibleForAllTimeGraph && <DashboardGraphExpandLink allHistory onClick={graphExpandButtonClickHandler.bind(this,dataViewName,dataViewSlug)}>Expanded All-History Graph</DashboardGraphExpandLink>}
      </DashboardGraphExpandLinkCell>
      <DashboardGraphExpandLinkCell><DashboardGraphExpandLink onClick={graphExpandButtonClickHandler.bind(this,dataViewName,"rainfall-totals-daily")}>Daily Totals</DashboardGraphExpandLink></DashboardGraphExpandLinkCell>
      <DashboardGraphExpandLinkCell><DashboardGraphExpandLink onClick={graphExpandButtonClickHandler.bind(this,dataViewName,"rainfall-totals-monthly")}>Monthly Totals</DashboardGraphExpandLink></DashboardGraphExpandLinkCell>
      <DashboardGraphExpandLinkCell><DashboardGraphExpandLink onClick={graphExpandButtonClickHandler.bind(this,dataViewName,"rainfall-totals-yearly")}>Yearly Totals</DashboardGraphExpandLink></DashboardGraphExpandLinkCell>
    </DashboardGraphExpandLinkRow>
    <DashboardGraphInnerContainer id={`graph-container-${new Date().getTime()}`} ref={ref}>
      {children}
    </DashboardGraphInnerContainer>
  </DashboardGraphContainer>
  })


export default class Dashboard extends React.Component {

  constructor(props) {

    super(props)

    const layoutWidth=this.getLayoutWidth()
    const layoutHeight=this.getLayoutHeight()
    const isSmallScreen=(layoutWidth < styledTheme.breakpoints.lg)
    const mobileLandscapeView=(isSmallScreen && (layoutWidth > layoutHeight))

    this.state = {
      layoutWidth,
      layoutHeight,
      isSmallScreen,
      mobileLandscapeView,
      vtdGraphOptions: null,
      temperatureGraphOptions: null,
      windGraphOptions: null,
      relativeHumidityDeltaTGraphOptions: null,
      ghcopGraphOptions: null,
      gfdiGraphOptions: null,
      rainfallGraphOptions: null,
      dewPointGraphOptions: null,
      showSigmaW: true,
      showVTD: true,
      showGhcop: true,
    }

    this.sigmawGraphContainer = React.createRef()
    this.sigmawGraphChart = React.createRef()
    this.sigmaw2hrGraphContainer = React.createRef()
    this.sigmaw2hrGraphChart = React.createRef()
    this.vtdGraphContainer = React.createRef()
    this.vtdGraphChart = React.createRef()
    this.temperatureGraphContainer = React.createRef()
    this.temperatureGraphChart = React.createRef()
    this.windGraphContainer = React.createRef()
    this.windGraphChart = React.createRef()
    this.relativeHumidityDeltaTGraphContainer = React.createRef()
    this.relativeHumidityDeltaTGraphChart = React.createRef()
    this.ghcopGraphContainer = React.createRef()
    this.ghcopGraphChart = React.createRef()
    this.gfdiGraphContainer = React.createRef()
    this.gfdiGraphChart = React.createRef()
    this.rainfallGraphContainer = React.createRef()
    this.rainfallGraphChart = React.createRef()
    this.dewPointGraphContainer = React.createRef()
    this.dewPointGraphChart = React.createRef()

    this.dashboardHoverSync = createDashboardHoverSync({ getCharts: this.getMountedCharts })

    initialiseHighcharts(Highcharts)

  }

  componentDidMount = () => {
    this.loadDashboardContent(this.state)
    window.addEventListener('resize', this.resizeHandler)
    this.dashboardHoverSync.bind()
    //console.log("rainfallGraphChart",this.rainfallGraphChart)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeHandler)
    this.dashboardHoverSync.unbind()
    //console.log("rainfallGraphChart",this.rainfallGraphChart)
  }

  componentDidUpdate = (oldProps,oldState) => {
    this.loadDashboardContent(oldState)
    this.dashboardHoverSync.bind()
    //console.log("rainfallGraphChart",this.rainfallGraphChart)
  }

  getChartRefSets = () => [
    [this.sigmawGraphContainer,this.sigmawGraphChart],
    [this.sigmaw2hrGraphContainer,this.sigmaw2hrGraphChart],
    [this.vtdGraphContainer,this.vtdGraphChart],
    [this.temperatureGraphContainer,this.temperatureGraphChart],
    [this.windGraphContainer,this.windGraphChart],
    [this.relativeHumidityDeltaTGraphContainer,this.relativeHumidityDeltaTGraphChart],
    [this.ghcopGraphContainer,this.ghcopGraphChart],
    [this.gfdiGraphContainer,this.gfdiGraphChart],
    [this.rainfallGraphContainer,this.rainfallGraphChart],
    [this.dewPointGraphContainer,this.dewPointGraphChart],
  ]

  getMountedCharts = () => this.getChartRefSets()
    .map(([, chartRef]) => chartRef.current && chartRef.current.chart)
    .filter((chart) => chart && chart.container)

  loadDashboardContent = (oldState) => {
    const awsType = this.props.site && this.props.site.aws_type
    const isMesonet = this.props.site && this.props.site.mesonet
    const showSigmaW = isMesonet
    const showVTD = isMesonet && (!['hilltop'].includes(awsType))
    const showGhcop = (isMesonet || ['greenbrain'].includes(awsType)) && (!['hilltop'].includes(awsType))
    const showGfdi = !['greenbrain'].includes(awsType)
    const showDewPoint = !['greenbrain'].includes(awsType)

    if (this.props.data && this.props.data.graphs && (
      (this.state.showSigmaW && !oldState.sigmawGraphOptions) ||
      (this.state.showSigmaW && !oldState.sigmaw2hrGraphOptions) ||
      (this.state.showVTD && !oldState.vtdGraphOptions) ||
      (this.state.showGhcop && !oldState.ghcopGraphOptions) ||
      (this.state.showGfdi && !oldState.gfdiGraphOptions) ||
      !oldState.temperatureGraphOptions ||
      !oldState.windGraphOptions ||
      !oldState.relativeHumidityDeltaTGraphOptions ||
      !oldState.rainfallGraphOptions ||
      (this.state.showDewPoint && !oldState.dewPointGraphOptions)
    )) {
      this.setState({
        sigmawGraphOptions: showSigmaW ? this.processedGraphOptions((this.props.data.graphs.ann_sigma_w || this.props.data.graphs.graph_ann_sigma_w || this.props.data.graphs.graph_sigmaw),this.sigmawGraphContainer,this.sigmawGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        sigmaw2hrGraphOptions: showSigmaW ? this.processedGraphOptions((this.props.data.graphs.ann_2hr_sigma_w || this.props.data.graphs.graph_ann_2hr_sigma_w),this.sigmaw2hrGraphContainer,this.sigmaw2hrGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        vtdGraphOptions: showVTD ? this.processedGraphOptions((this.props.data.graphs.vtd || this.props.data.graphs.graph_vtd),this.vtdGraphContainer,this.vtdGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        ghcopGraphOptions: showGhcop ? this.processedGraphOptions((this.props.data.graphs.ghcop || this.props.data.graphs.graph_ghcop),this.ghcopGraphContainer,this.ghcopGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        gfdiGraphOptions: showGfdi ? this.processedGraphOptions((this.props.data.graphs.gfdi || this.props.data.graphs.graph_gfdi),this.gfdiGraphContainer,this.gfdiGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        temperatureGraphOptions: this.processedGraphOptions((this.props.data.graphs.temperature || this.props.data.graphs.graph_temperature),this.temperatureGraphContainer,this.temperatureGraphChart,{ timezone_name: this.props.site.timezone_name }),
        windGraphOptions: this.processedGraphOptions((this.props.data.graphs.wind || this.props.data.graphs.graph_wind),this.windGraphContainer,this.windGraphChart,{ timezone_name: this.props.site.timezone_name }),
        relativeHumidityDeltaTGraphOptions: this.processedGraphOptions((this.props.data.graphs.relative_humidity_delta_t || this.props.data.graphs.graph_relative_humidity_delta_t),this.relativeHumidityDeltaTGraphContainer,this.relativeHumidityDeltaTGraphChart,{ timezone_name: this.props.site.timezone_name }),
        rainfallGraphOptions: this.processedGraphOptions((this.props.data.graphs.rainfall || this.props.data.graphs.graph_rainfall),this.rainfallGraphContainer,this.rainfallGraphChart,{ timezone_name: this.props.site.timezone_name }),
        dewPointGraphOptions: showDewPoint ? this.processedGraphOptions((this.props.data.graphs.dew_point || this.props.data.graphs.graph_dew_point),this.dewPointGraphContainer,this.dewPointGraphChart,{ timezone_name: this.props.site.timezone_name }) : null,
        showSigmaW: showSigmaW,
        showVTD: showVTD,
        showGhcop: showGhcop,
        showGfdi: showGfdi,
        showDewPoint: showDewPoint,
      })
    }
  }

  getLayoutWidth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.offsetWidth
  }

  getLayoutHeight = () => {
    if (typeof window === 'undefined') return (styledTheme.breakpoints.lg*9/16)
    return window.offsetHeight
  }

  processedGraphOptions = (options,containerRef,chartRef,extraOptions = {}) => {

    if (!options) {
      return {}
    }

    options['scrollbar'] = { enabled: true }
    options['legend'] = { enabled: false }

    options['rangeSelector'] = {
      enabled: true,
      inputEnabled: false,
      buttons: [{
        type: 'day',
        count: 1,
        text: '1d'
      },{
        type: 'day',
        count: 2,
        text: '2d'
      },{
        type: 'week',
        count: 1,
        text: '1w'
      }]
    }

    const xAxes = options['xAxis']
    const maxUnixTimeMoment = Moment(new Date(xAxes[0]['max']))
    const twoDaysAgoUnixtime = maxUnixTimeMoment.clone().subtract(2,'days')
    const xAxisRange = maxUnixTimeMoment.diff(twoDaysAgoUnixtime)
    xAxes[0]['min'] = xAxes[0]['max']-xAxisRange
    xAxes['startOnTick'] = true
    xAxes['endOnTick'] = true
    xAxes['ordinal'] = false

    if (containerRef.current) {
      const containerHeight = containerRef.current.offsetHeight
      const containerWidth = containerRef.current.offsetWidth
      options.chart['height'] = containerHeight
      options.chart['width'] = containerWidth
    }

    options.chart['events']['load'] = ((event) => {
      event.target['yAxis'].forEach((axis) => {
        if (axis.userOptions.id==="y_axis_km_h") {
          axis.update({
            min: axis['dataMin'],
            max: axis['dataMax'],
          })
        }
      })
    })

    attachWindDirectionRedrawHandler({
      options,
      convertDegreesToIconAngle,
    })

    options['yAxis'] = formatYAxis(options['yAxis'].slice())

    options['series'] = formatSeries(options['series'].slice())

    options['time'] = buildTimezoneOptions(extraOptions['timezone_name'])

    const xAxis = xAxes[0]

    const xAxisMin = xAxis.min
    const xAxisMax = xAxis.max
    const xAxisRangeDiff = xAxisMax-xAxisMin

    options['rangeSelector'] = buildRangeSelector(xAxisRangeDiff)

    return options

  }

  resizeHandler = (e) => {

    const graphRefSets = this.getChartRefSets()

    graphRefSets.forEach((graphRefSets) => {

      const container = graphRefSets[0].current
      const graph = graphRefSets[1].current

      if ((!container) || (!graph)) return true

      let last3Widths = []
      let last3Heights = []

      const resizeFunction = () => {
        const containerWidth = container.offsetWidth
        const containerHeight = container.offsetHeight
        const graphWidth = containerWidth-2
        const graphHeight = containerHeight-2
        graph.chart.setSize(
          graphWidth,
          graphHeight,
        )
        graph.chart.reflow()

      }

      const intervalId = setInterval(() => {
        last3Widths.push(container.offsetWidth)
        last3Heights.push(container.offsetHeight)
        last3Widths = last3Widths.slice(-3)
        last3Heights = last3Heights.slice(-3)
        if ((last3Widths.length < 3) || (last3Heights.length < 3)) {
          resizeFunction()
        } else {
          const widthTotal = last3Widths.reduce((n,total) => total+n,0)
          const heightTotal = last3Heights.reduce((n,total) => total+n,0)
          if (((widthTotal/3)===last3Widths[2]) && ((heightTotal/3)===last3Heights[2])) {
            clearInterval(intervalId)
          } else {
            resizeFunction()
          }
        }
      },500)
    })
  }

  siteDataViewsButtonClickHandler = () => {
    const { site, routeToSiteDataViewsListHandler } = this.props
    ReactGA.event({
      category: 'Site Action',
      action: `View Site Data Views List from Dashboard`,
      label: site.name,
    })
    routeToSiteDataViewsListHandler.call(this,site.slug)
  }

  graphExpandButtonClickHandler = (dataViewName,dataViewSlug) => {
    const { site, routeToDataViewHandler } = this.props
    const siteSlug = site.slug
    const siteName = site.name
    ReactGA.event({
      category: 'Site Action',
      action: `Expand Graph from Dashboard`,
      label: `${siteName}:${dataViewName}`,
      site: site.name,
      data_view_name: dataViewName,
    })
    routeToDataViewHandler.call(this,siteSlug,dataViewSlug)
  }

  renderBody = (props,state,refs) => {
    const { data, site, routeToSiteDataViewsListHandler, fetching } = props
    const title = (data && data.site_name) ? `Dashboard: ${data.site_name}` : ''
    const siteEligibleForAllTimeGraph = isSiteEligibleForAllTimeGraph(props.user, site);

    return <DataViewModalContainer>
      <LoadingIndicator show={fetching} />
      <HelmetTitle title={title} />
      {<ContainerHeading
        title={title}
        actionIcons={
          <ContainerHeadingActionIcon onClick={this.props.closeDataViewHandler}><CloseCircle /></ContainerHeadingActionIcon>
        }
      />}
      <DashboardContainer>
        { data && data.site_summary && routeToSiteDataViewsListHandler && <Toolbar dashboardToolbarExpandLinkClickHandler={this.siteDataViewsButtonClickHandler} />}

        {data && data.graphs && this.state.showSigmaW && (data.graphs.ann_sigma_w || data.graphs.graph_ann_sigma_w || data.graphs.graph_sigmaw) && <Graph
          title={"Hazardous Inversion"}
          state={state}
          ref={this.sigmawGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'hazardous-inversion'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.sigmawGraphOptions && <HighchartsReact
              ref={this.sigmawGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.sigmawGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }

        {data && data.graphs && this.state.showSigmaW && (data.graphs.ann_2hr_sigma_w || data.graphs.graph_ann_2hr_sigma_w) && <Graph
          title={"2hr Prediction Hazardous Inversion"}
          state={state}
          ref={this.sigmaw2hrGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'2hr-hazardous-inversion'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.sigmaw2hrGraphOptions && <HighchartsReact
              ref={this.sigmaw2hrGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.sigmaw2hrGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }

        {data && data.graphs && this.state.showVTD && (data.graphs.vtd || data.graphs.graph_vtd) && <Graph
          title={"Inversion: Vertical Temperature Difference"}
          state={state}
          ref={this.vtdGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'vertical-temperature-difference'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.vtdGraphOptions && <HighchartsReact
              ref={this.vtdGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.vtdGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }

        {data && data.graphs && this.state.showGhcop && (data.graphs.ghcop || data.graphs.graph_ghcop) && <Graph
          title={"Grain Harvest Code of Practice (GHCoP, wind@2m)"}
          state={state}
          ref={this.ghcopGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'grain-harvest-code-of-practice-ghcop-wind2m'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.ghcopGraphOptions && <HighchartsReact
              ref={this.ghcopGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.ghcopGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }

        {data && data.graphs && <Graph
          title={"Temperatures"}
          state={state}
          ref={this.temperatureGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'temperatures'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.temperatureGraphOptions && <HighchartsReact
              ref={this.temperatureGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.temperatureGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }
        {data && data.graphs && (data.graphs.wind || data.graphs.graph_wind) && <Graph
          title={"Wind"}
          state={state}
          ref={this.windGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'wind'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.windGraphOptions && <HighchartsReact
              ref={this.windGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.windGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }
        {data && data.graphs && (data.graphs.relative_humidity_delta_t || data.graphs.graph_relative_humidity_delta_t) && <Graph
          title={"Relative Humidity & Delta T"}
          state={state}
          ref={this.relativeHumidityDeltaTGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'relative-humidity-delta-t'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.relativeHumidityDeltaTGraphOptions && <HighchartsReact
              ref={this.relativeHumidityDeltaTGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.relativeHumidityDeltaTGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }
        {data && data.graphs && (data.graphs.rainfall || data.graphs.graph_rainfall) && <RainfallGraph
          title={"Rainfall"}
          state={state}
          ref={this.rainfallGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'rainfall'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.rainfallGraphOptions && <HighchartsReact
              ref={this.rainfallGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.rainfallGraphOptions}
              allowChartUpdate={false}
            />
          }
        </RainfallGraph>
        }
        {data && data.graphs && this.state.showDewPoint && (data.graphs.dew_point || data.graphs.graph_dew_point) && <Graph
          title={"Dew Point"}
          state={state}
          ref={this.dewPointGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'dew-point'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.dewPointGraphOptions && <HighchartsReact
              ref={this.dewPointGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.dewPointGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }
        {data && data.graphs && this.state.showGfdi && (data.graphs.gfdi || data.graphs.graph_gfdi) && <Graph
          title={"GFDI"}
          state={state}
          ref={this.gfdiGraphContainer}
          siteSlug={site.slug}
          dataViewSlug={'gfdi-wind10m'}
          siteEligibleForAllTimeGraph={siteEligibleForAllTimeGraph}
          graphExpandButtonClickHandler={this.graphExpandButtonClickHandler}
        >
          {
            this.state.gfdiGraphOptions && <HighchartsReact
              ref={this.gfdiGraphChart}
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={this.state.gfdiGraphOptions}
              allowChartUpdate={false}
            />
          }
        </Graph>
        }
      </DashboardContainer>
    </DataViewModalContainer>
  }

  render = () => this.renderBody(this.props,this.state,this.refs)

}
